import(/* webpackMode: "eager" */ "/app/.next/cache/webpack/next-with-linaria/production/css/@linaria-css/src_components_Typography_index_ts.linaria.module.css");
;
import(/* webpackMode: "eager" */ "/app/.next/cache/webpack/next-with-linaria/production/css/@linaria-css/src_components_ChatMain_styles_ts.linaria.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next-runtime-env/build/provider/env-provider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next-runtime-env/build/provider/use-env-context.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/public/assets/icons/no-messages.svg");
;
import(/* webpackMode: "eager", webpackExports: ["Client"] */ "/app/src/components/ChatMain/client.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useShowBotPaywall"] */ "/app/src/features/paywall/hooks/useShowBotPaywall.ts");
;
import(/* webpackMode: "eager", webpackExports: ["Paywall","useShowPaywall"] */ "/app/src/features/paywall/hooks/useShowPaywall.ts");
;
import(/* webpackMode: "eager", webpackExports: ["BotPaywallContextRecipient"] */ "/app/src/features/paywall/ui/BotPaywallContextRecipient/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NeuronsModal"] */ "/app/src/features/paywall/ui/NeuronsModal/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SubscriptionModal"] */ "/app/src/features/paywall/ui/SubscriptionModal/index.tsx");
